import React, { useRef } from "react";
import { NavLink } from "react-router-dom";
import { Collapse } from "bootstrap";

const Navbar = () => {
  const collapseRef = useRef(null);

  const closeNavbar = () => {
    if (collapseRef.current) {
      const bsCollapse = new Collapse(collapseRef.current, { toggle: false });
      bsCollapse.hide();
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container-fluid">
        <span className="navbar-brand">- _ ~</span>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav" ref={collapseRef}>
          <ul className="navbar-nav">
            {/* <li className="nav-item">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? 'nav-link text-light active' : 'nav-link text-light'
                }
                onClick={closeNavbar}
              >
                Home
              </NavLink>
            </li> */}
            {/* <li className="nav-item">
              <NavLink
                to="/stocks"
                className={({ isActive }) =>
                  isActive ? 'nav-link text-light active' : 'nav-link text-light'
                }
                onClick={closeNavbar}
              >
                Stocks
              </NavLink>
            </li> */}
            <li className="nav-item">
              <NavLink
                to="/top-smart-score-stocks"
                className={({ isActive }) => (isActive ? "nav-link text-light active" : "nav-link text-light")}
                onClick={closeNavbar}
              >
                Top Smart Score Stocks
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/top-analysts-stocks"
                className={({ isActive }) => (isActive ? "nav-link text-light active" : "nav-link text-light")}
                onClick={closeNavbar}
              >
                Top Analysts Stocks
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/top-smart-score-stocks-ca"
                className={({ isActive }) => (isActive ? "nav-link text-light active" : "nav-link text-light")}
                onClick={closeNavbar}
              >
                Top Smart Score Stocks 🇨🇦
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/top-analysts-stocks-ca"
                className={({ isActive }) => (isActive ? "nav-link text-light active" : "nav-link text-light")}
                onClick={closeNavbar}
              >
                Top Analysts Stocks 🇨🇦
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
